<template>
  <section>
    <v-card dark class="gradient__withAnimation">
      <particles>
        <home-toolbar></home-toolbar>
        <banner :item="banner"></banner>
      </particles>
    </v-card>

    <section-content :item="content"></section-content>

    <footer-component></footer-component>
  </section>
</template>

<script>
import store from '@/store'
import Banner from './template/Banner'
import SectionContent from './template/Content'
import banner from '@/modules/CDA/Programmes/assets/images/act.svg'

export default {
  store,
  name: 'Act',

  components: {
    Banner,
    SectionContent,
  },

  data () {
    return {
      banner: {
        thumbnail: banner,
        title: 'Cybersecurity Act 2018 Compliance',
      },

      content: {
        md8: true,
        overview: '<p>This programme seeks to equip participants with the knowledge and skills to comply with Singapore’s Cybersecurity Act 2018. </p><p>Taking a practical approach, the programme explains the requirements of the Cybersecurity Act 2018 and walks through the end to end compliance process and includes operational guidance on how to manage a compliance programme from design, development, monitoring, reporting and review.  Participants will also be taught how to determine and monitor compliance deliverables including designing cybersecurity risk management programmes as part of the overall cybersecurity governance, risk and compliance framework; cybersecurity impact assessment; managing technology related to compliance; and how to build overall capabilities in cybersecurity regulatory risk management.</p><p>While the programme is focused on Singapore law, the learnings from this programme can be applied across any jurisdiction to better manage cybersecurity legal and regulatory compliance risks. </p> ',

        outcome: 'By attending this programme, participants will be equipped with the knowledge, skills and toolkits to: <br><ul><li>Better understand the concepts and principles underlying the provisions in the Cybersecurity Act 2018.</li><li>Carry out effective compliance programmes through the use of checklists, control measures, standard operating procedures and developing techniques for compliance strategy design and project management.</li> <li>Learn from real life case studies using concrete examples of compliance practices in other markets. Participants would get a good grounding on what it takes to design and operationalise sound compliance programmes in cybersecurity legal and regulatory risk management.</li></ul>',
        outline: '<p>Objectives of the Cybersecurity Act</p><p>Protection of Critical Information Infrastructure Against Cyber-attacks</p><p>Authorisation of Cyber Security Agency</p><p>Framework for Sharing Cybersecurity Information</p><p>Licensing Framework for Cybersecurity Service Providers</p><p>Cybersecurity Governance Risk & Compliance Framework</p><ul><li>Compliance Methodologies</li><li>Compliance Strategy and Programme Design</li><li>Business Impact Analysis</li><li>Business Risk Assessment</li><li>Audit Readiness</li><li>Privacy Impact Assessment</li></ul><p>Compliance Processes & Standard Operating Procedures</p><p>Executing the Compliance Programme</p><p>Policy & Legal Agreements</p><p>Cybersecurity Capability Building & Training</p>',

        audience: {
          showTargetAudience: true,
          items: [
            { icon: 'mdi-check-outline', title: 'Cybersecurity and IT professionals' },
            { icon: 'mdi-check-outline', title: 'Compliance officers' },
            { icon: 'mdi-check-outline', title: 'Business executives' },
            { icon: 'mdi-check-outline', title: 'Lawyers (both practitioners and in house legal counsels)' },
            { icon: 'mdi-check-outline', title: 'Policy makers tasked to ensure compliance of the Cybersecurity Act 2018' },
          ]
        }
      },
    }
  },
}
</script>
